import {
    ServerActionWidget,
    SPI,
    ActionWidget,
    ActionType,
    ClickResult,
    RuntimeServerAction,
    SubmitValue,
    ActiveRecord
} from '@kunlun/dependencies';
import { OioNotification } from '@kunlun/vue-ui-antd';


@SPI.ClassFactory(
    ActionWidget.Token({
        actionType: ActionType.Server,
        name: 'create',
        model: 'aries.merchant.MerchantCustomerRebateBill'
    })
)
export class rebateSubmitWidget extends ServerActionWidget {
    protected executeAction(action: RuntimeServerAction, submitValue: SubmitValue): Promise<ClickResult> {
        const submitValueCopy = { ...submitValue }
        submitValueCopy.records = this.activeRecords?.[0] ?? {}
        return super.executeAction(action, submitValueCopy);
    }
}
